import M from '@materializecss/materialize';
import { useCallback, useEffect, useRef, useState } from 'react';

const UnmatchedCreditsModal = ({
  isOpen,
  setIsOpen,
  unmatchedCredits,
  updateUnmatchedCredit,
  sheet,
}) => {
  const modal = useRef(null);

  const [currentDebitMemo, setCurrentDebitMemo] = useState();
  const [debitMemoId, setDebitMemoId] = useState(0);

  useEffect(() => {
    const { current } = modal;
    if (current) {
      M.Modal.init(current, {
        onOpenEnd: M.updateTextFields,
        onCloseEnd: () => setIsOpen(false),
      });
      return () => {
        if (current) M.Modal.getInstance(current)?.destroy();
      };
    }
  }, [modal, setIsOpen]);

  const getModal = useCallback(
    () => (modal.current ? M.Modal.getInstance(modal.current) : null),
    [modal]
  );
  const open = useCallback(() => getModal()?.open(), [getModal]);
  const close = useCallback(() => getModal()?.close(), [getModal]);

  useEffect(() => {
    isOpen ? open() : close();
  }, [isOpen, close, open]);

  useEffect(() => {
    if (!unmatchedCredits || !sheet) return;
    if (!unmatchedCredits.length) return close();

    const unmatchedCredit = unmatchedCredits?.[0];
    const row = sheet?.find(
      row =>
        row?.[`Reported Debit Memo Number`] ===
        unmatchedCredit?.reportedDebitMemoNumber
    );
    setCurrentDebitMemo({
      reportedDebitMemoNumber: unmatchedCredit?.reportedDebitMemoNumber,
      reportedManufacturerName: row?.[`Reported Manufacturer Name`],
      fullCreditAmount: row?.[`Full Credit Amount`],
    });
  }, [unmatchedCredits, sheet, close]);

  const update = useCallback(
    event => {
      event.preventDefault();
      updateUnmatchedCredit(
        currentDebitMemo.reportedDebitMemoNumber,
        debitMemoId
      );
    },
    [currentDebitMemo, debitMemoId, updateUnmatchedCredit]
  );

  return (
    <div ref={modal} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5 className="center">Unmatched Credits</h5>
          <small>{unmatchedCredits?.length} remaining</small>
          <div className="divider" />
        </div>
        <div className="row">
          <p>
            Reported Debit Memo Number:{' '}
            <b>{currentDebitMemo?.reportedDebitMemoNumber}</b>
          </p>
          <p>
            Reported Manufacturer:{' '}
            <b>{currentDebitMemo?.reportedManufacturerName}</b>
          </p>
          <p>
            Full Credit Amount: <b>{currentDebitMemo?.fullCreditAmount}</b>
          </p>
        </div>
        <div className="row">
          <div className="input-field col s12 m3 offset-m9">
            <input
              id="debitMemoId"
              type="number"
              value={debitMemoId}
              onChange={({ target: { value } }) => setDebitMemoId(value)}
            />
            <label htmlFor="debitMemoId">Debit Memo ID</label>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m4 offset-m4">
            <a
              href="/"
              className="btn-small blue white-text waves-effect waves-light col s12"
              onClick={update}
            >
              Update Credit
            </a>
          </div>
          <div className="col s12 m4">
            <a
              href="/"
              className="btn-small white blue-text waves-effect waves-dark col s12"
              onClick={e => {
                e.preventDefault();
                setIsOpen(false);
              }}
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnmatchedCreditsModal;
